import React from 'react';

const MediaGalleryContent = ({
  heading,
  text,
  links,
  showAuthor,
  photographer,
  illustrator,
  translations,
}) => {
  return (
    <>
      {heading && <h3 style={{ marginBottom: '15px' }}>{heading}</h3>}
      {text && (
        <div
          className="c-media-gallery__item__text"
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        ></div>
      )}
      {showAuthor && (
        <div className="c-media-gallery__item__text__photo-cred">
          {photographer && (
            <p>{`${translations.photographer}: ${photographer}`}</p>
          )}
          {illustrator && (
            <p>{`${translations.illustrator}: ${illustrator}`}</p>
          )}
        </div>
      )}
      {links && (
        <div className="c-media-gallery__item__linklist">
          <div className="c-linklist">
            <ul className="c-linklist__list">
              {links.map((link, index) => (
                <li key={index}>
                  <a className="c-anchor c-linklist__link" href={link.Href}>
                    <span>{link.Text}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default MediaGalleryContent;
